import { useWebTranslation, Trans } from "translations";
import Gutter from "ui-kit/Gutter";
import { FlexCol } from "ui-kit/Layout/Flex";
import { Panel } from "ui-kit/Panels";
import { Typography } from "ui-kit/Typography";
import styles from "./PaymentInfo.module.css";
import { FC } from "react";
import { BillingInterval } from "utils/insurance";

type PaymentInfoProps = {
  billingInterval: BillingInterval;
};

const PaymentInfo: FC<PaymentInfoProps> = ({ billingInterval }) => {
  const { t } = useWebTranslation();
  const isYearlyPayment = billingInterval === 12;

  return isYearlyPayment ? (
    <Panel variant="info" title={t("payment_info.yearly_title")} expandable>
      <Gutter size={2} />
      <Typography variant="body3" className={styles.text}>
        <Trans i18nKey="payment_info.yearly_payment_text" />
      </Typography>
    </Panel>
  ) : (
    <Panel variant="info" title={t("payment_info.title")} expandable>
      <Gutter size={2} />
      <ul className={styles.list}>
        <li className={styles.item}>
          <FlexCol>
            <Typography variant="body3">
              <strong>{t("payment_info.first_payment_title")}</strong>
            </Typography>
            <Gutter size={1} />
            <Typography variant="body3">
              <Trans i18nKey="payment_info.first_payment_text" />
            </Typography>
          </FlexCol>
        </li>
        <Gutter size={1} />
        <li className={styles.item}>
          <FlexCol>
            <Typography variant="body3">
              <strong>{t("payment_info.recurring_payment_title")}</strong>
            </Typography>
            <Gutter size={1} />
            <Typography variant="body3">
              {t("payment_info.recurring_payment_text")}
            </Typography>
          </FlexCol>
        </li>
      </ul>
    </Panel>
  );
};

export default PaymentInfo;
